export const tempschedule = [{
    text: "Практика 1",
    startDate: new Date('2019-12-23 09:00:00'),
    endDate: new Date('2019-12-23 11:30:00'),
    allDay: "false"
  }, {
    text: "Лекция 5",
    startDate: new Date('2019-12-24T12:00:00'),
    endDate: new Date('2019-12-24T13:30:00'),
    allDay: "false"
  }];
